




































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { apiSupplierStatus, apiSupplierAccountDetail, apiSupplierAccountEdit } from '@/api/material'

@Component
export default class SupplierPane extends Vue {
    @Prop({ type: Array, default: () => [] }) value!: any[]
    @Prop({ type: Object, required: true }) pager!: any

    // 修改账号对话框相关
    editAccountDialogVisible = false
    editAccountLoading = false
    editAccountForm = {
      supplier_id: 0,
      supplier_name: '',
      username: '',
      password: '',
      status: 1
    }

    formatMoney (value: any) {
      if (!value) {
        return '0.00'
      }
      return Number(value).toFixed(2)
    }

    // 处理修改账号
    async handleEditAccount (row: any) {
      this.editAccountForm = {
        supplier_id: row.id,
        supplier_name: row.supplier_name,
        username: '',
        password: '',
        status: 1
      }

      try {
        // 获取供应商账号详情
        const accountDetail = await apiSupplierAccountDetail({ supplier_id: row.id })
        if (accountDetail) {
          this.editAccountForm.username = accountDetail.username || ''
          this.editAccountForm.status = accountDetail.status || 1
        }
      } catch (error) {
        console.error('获取供应商账号详情失败:', error)
      }

      this.editAccountDialogVisible = true
    }

    // 确认修改账号
    confirmEditAccount () {
      if (!this.editAccountForm.username || this.editAccountForm.username.length < 4 || this.editAccountForm.username.length > 50) {
        this.$message.error('登录账号长度必须在4-50个字符之间')
        return
      }
      if (this.editAccountForm.password && (this.editAccountForm.password.length < 6 || this.editAccountForm.password.length > 20)) {
        this.$message.error('登录密码长度必须在6-20个字符之间')
        return
      }

      this.editAccountLoading = true

      // 调用修改账号接口
      apiSupplierAccountEdit({
        supplier_id: this.editAccountForm.supplier_id,
        username: this.editAccountForm.username,
        password: this.editAccountForm.password,
        status: this.editAccountForm.status
      }).finally(() => {
        this.editAccountLoading = false
        this.editAccountDialogVisible = false
        this.$emit('refresh')
      })
    }

    handleEdit (row: any) {
      this.$router.push({
        path: '/material/supplier_edit',
        query: { id: row.id }
      })
    }

    handleDetail (row: any) {
      this.$router.push({
        path: '/material/supplier_detail',
        query: { id: row.id }
      })
    }

    handleToggleStatus (row: any) {
      const newStatus = row.cooperation_status === 1 ? 2 : 1
      const action = row.cooperation_status === 1 ? '暂停' : '恢复'

      this.$confirm(`确定要${action}与供应商"${row.supplier_name}"的合作吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apiSupplierStatus({
          id: row.id,
          cooperation_status: newStatus
        }).then((res: any) => {
          this.$message.success(`${action}合作成功`)
          this.$emit('refresh')
        })
      })
    }

    handleSizeChange (size: number) {
      this.pager.size = size
      this.$emit('refresh')
    }

    handleCurrentChange (page: number) {
      this.pager.page = page
      this.$emit('refresh')
    }

    @Emit()
    getList (page?: number) {
      return page
    }
}
